import { PATH, authDelete, authGetAll, authPatch, authPost } from '../../http';
import {
  EntityGroup,
  EntityGroupSearchParams,
  GetEntityByType,
  Id,
} from '../types';

export const getEntitiesByType = async (params: GetEntityByType) => {
  return await authGetAll(
    `api/v1/${PATH.QUESTIONARIES}/${PATH.ENTITIES}/`,
    params,
  );
};

export const getEntitiesByGroupId = async (groupId: string) => {
  return await authGetAll(
    `api/v1/${PATH.ENTITY_GROUP}/${groupId}/${PATH.ENTITIES}`,
  );
};

export const getAllEntitiesGroup = async () => {
  return await authGetAll(`api/v1/${PATH.ENTITY_GROUP}/`);
};

export const getEntityGroupById = async ({ id }: Id) => {
  return await authGetAll(`api/v1/${PATH.ENTITY_GROUP}/${id}`);
};

export const createEntityGroup = async (entityGroup: EntityGroup) => {
  return await authPost(`api/v1/${PATH.ENTITY_GROUP}/`, entityGroup);
};

export const searchEntityGroup = async (params: EntityGroupSearchParams) => {
  return await authPost(`api/v1/${PATH.ENTITY_GROUP}/search`, params);
};

export const patchEntityGroup = async (entityGroup: EntityGroup) => {
  return await authPatch(
    `api/v1/${PATH.ENTITY_GROUP}/${entityGroup.id}`,
    entityGroup,
  );
};

export const deleteEntityGroup = async ({ id }: Id) => {
  return await authDelete(`api/v1/${PATH.ENTITY_GROUP}/${id}`);
};
